import { render, staticRenderFns } from "./AdminProduction.vue?vue&type=template&id=3f00ab34"
import script from "./AdminProduction.vue?vue&type=script&lang=js"
export * from "./AdminProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports